import { Token } from '@uniswap/sdk-core'
import { LightCard } from 'components/Card'
import { AutoColumn } from 'components/Column'
import { RowBetween } from 'components/Row'
import { formatAmount } from 'nft/utils/numbers'
import styled from 'styled-components'

const TooltipWrapper = styled(LightCard)`
  padding: 12px;
  width: 320px;
  font-size: 12px;
  z-index: 10;
  background: rgba(31, 36, 46, 0.9);
  border: 1px solid rgba(109, 119, 135, 0.2);
`

interface CustomToolTipProps {
  chartProps: any
  token0: Token
  token1: Token
  currentPrice: number | undefined
}

function CustomToolTip({ chartProps, token0, token1, currentPrice }: CustomToolTipProps) {
  const price0 = chartProps?.payload?.[0]?.payload.price0
  const price1 = chartProps?.payload?.[0]?.payload.price1
  const tvlToken0 = chartProps?.payload?.[0]?.payload.tvlToken0
  const tvlToken1 = chartProps?.payload?.[0]?.payload.tvlToken1

  return (
    <TooltipWrapper>
      <AutoColumn gap="sm">
        <div>Tick stats</div>
        <RowBetween>
          <div>{token0?.symbol} Price: </div>
          <div>
            {price0
              ? Number(price0).toLocaleString(undefined, {
                  minimumSignificantDigits: 1,
                })
              : ''}{' '}
            {token1?.symbol}
          </div>
        </RowBetween>
        <RowBetween>
          <div>{token1?.symbol} Price: </div>
          <div>
            {price1
              ? Number(price1).toLocaleString(undefined, {
                  minimumSignificantDigits: 1,
                })
              : ''}{' '}
            {token0?.symbol}
          </div>
        </RowBetween>
        {currentPrice && price0 && currentPrice > price1 ? (
          <RowBetween>
            <div>{token0?.symbol} Locked: </div>
            <div>
              {tvlToken0 ? formatAmount(tvlToken0) : ''} {token0?.symbol}
            </div>
          </RowBetween>
        ) : (
          <RowBetween>
            <div>{token1?.symbol} Locked: </div>
            <div>
              {tvlToken1 ? formatAmount(tvlToken1) : ''} {token1?.symbol}
            </div>
          </RowBetween>
        )}
      </AutoColumn>
    </TooltipWrapper>
  )
}

export default CustomToolTip
